// 移动端检测工具
export const mobileDetect = {
  // 检测是否为移动设备
  isMobile() {
    // 检测触摸能力
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // 检测用户代理
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUA = /mobile|android|iphone|ipad|phone|tablet/i.test(userAgent);
    
    // 检测屏幕尺寸
    const isSmallScreen = window.innerWidth <= 768;
    
    // 检测是否为触摸设备且屏幕较小
    const isTouchDevice = hasTouch && (isMobileUA || isSmallScreen);
    
    // 检测是否为真正的移动设备（排除桌面浏览器的触摸功能）
    const isRealMobile = isTouchDevice && (
      isMobileUA || 
      (window.innerWidth <= 768 && window.innerHeight <= 1024)
    );
    
    return isRealMobile;
  },
  
  // 检测是否为平板设备
  isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTabletUA = /tablet|ipad|android(?=.*\b(mobile|phone|tablet))/i.test(userAgent);
    const isTabletSize = window.innerWidth > 768 && window.innerWidth <= 1024;
    
    return isTabletUA || isTabletSize;
  },
  
  // 检测是否为小屏幕设备
  isSmallScreen() {
    return window.innerWidth <= 768;
  },
  
  // 检测是否为中等屏幕设备
  isMediumScreen() {
    return window.innerWidth > 768 && window.innerWidth <= 1024;
  },
  
  // 检测是否为大屏幕设备
  isLargeScreen() {
    return window.innerWidth > 1024;
  },
  
  // 获取设备类型
  getDeviceType() {
    if (this.isMobile()) return 'mobile';
    if (this.isTablet()) return 'tablet';
    if (this.isSmallScreen()) return 'small';
    if (this.isMediumScreen()) return 'medium';
    return 'large';
  },
  
  // 检测是否为横屏
  isLandscape() {
    return window.innerWidth > window.innerHeight;
  },
  
  // 检测是否为竖屏
  isPortrait() {
    return window.innerHeight > window.innerWidth;
  }
};

// 响应式断点
export const breakpoints = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1200,
  xl: 1400,
  xxl: 1600
};

// 响应式工具函数
export const responsive = {
  // 检查是否匹配断点
  is(breakpoint) {
    if (typeof breakpoint === 'string') {
      return window.innerWidth <= breakpoints[breakpoint];
    }
    return window.innerWidth <= breakpoint;
  },
  
  // 获取当前断点
  current() {
    if (window.innerWidth <= breakpoints.xs) return 'xs';
    if (window.innerWidth <= breakpoints.sm) return 'sm';
    if (window.innerWidth <= breakpoints.md) return 'md';
    if (window.innerWidth <= breakpoints.lg) return 'lg';
    if (window.innerWidth <= breakpoints.xl) return 'xl';
    return 'xxl';
  },
  
  // 添加响应式监听器
  addListener(callback) {
    let timeout;
    const handler = () => {
      clearTimeout(timeout);
      timeout = setTimeout(callback, 100);
    };
    
    window.addEventListener('resize', handler);
    window.addEventListener('orientationchange', handler);
    
    return () => {
      window.removeEventListener('resize', handler);
      window.removeEventListener('orientationchange', handler);
    };
  }
};
export default mobileDetect;

